import { Card } from '@mui/material';
import React from 'react';

/**
 * Reusable card component with green corner accents
 *
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Card content
 * @param {number} props.index - Card index for alternating corner positions
 * @param {Object} props.sx - Additional MUI sx styling
 * @param {Function} props.onClick - Click handler
 * @param {string} props.maxWidth - Maximum width of the card
 * @param {string} props.height - Height of the card
 * @returns {JSX.Element} Green corner card component
 */
function GreenCornerCard({
  children,
  index = 0,
  sx = {},
  onClick,
  maxWidth = '300px',
  height = '100%',
  ...props
}) {
  return (
    <Card
      sx={{
        height,
        maxWidth,
        width: '100%',
        mx: 'auto',
        transition: 'all 0.3s ease',
        cursor: onClick ? 'pointer' : 'default',
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08)',
        position: 'relative',
        border: '1px solid var(--color-border)',
        backgroundColor: 'var(--color-card)',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: -1,
          left: index % 2 === 0 ? -1 : 'auto',
          right: index % 2 === 1 ? -1 : 'auto',
          width: '40px',
          height: '40px',
          borderTop: '3px solid var(--color-primary)',
          borderLeft:
            index % 2 === 0 ? '3px solid var(--color-primary)' : 'none',
          borderRight:
            index % 2 === 1 ? '3px solid var(--color-primary)' : 'none',
          borderRadius: '0 !important',
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: -1,
          right: index % 2 === 0 ? -1 : 'auto',
          left: index % 2 === 1 ? -1 : 'auto',
          width: '40px',
          height: '40px',
          borderBottom: '3px solid var(--color-primary)',
          borderRight:
            index % 2 === 0 ? '3px solid var(--color-primary)' : 'none',
          borderLeft:
            index % 2 === 1 ? '3px solid var(--color-primary)' : 'none',
          borderRadius: '0 !important',
        },
        '&:hover': onClick
          ? {
              transform: 'translateY(-6px)',
              boxShadow: '0 8px 25px rgba(0, 0, 0, 0.15)',
            }
          : {},
        ...sx,
      }}
      onClick={onClick}
      {...props}
    >
      {children}
    </Card>
  );
}

export default GreenCornerCard;
